import React from 'react';

import { ResultRow, ResultsNameColumn, ResultsOrderNumber, CustomMessage } from './ZendeskOrderSearchResult.styles';

const ZendeskOrderSearchResult = ({ result, returnUrl, customMessage }) => {
  result['errorMessage'] = result['errorMessage'] ? result['errorMessage'] : '';

  return (
    <ResultRow>
      <ResultsNameColumn className="name-column">
        <ResultsOrderNumber>
          <CustomMessage>
            {result['errorMessage']} <br />
            {customMessage} <br />
            <br />
          </CustomMessage>
          For order details click{' '}
          <a
            href={returnUrl}
            target="_blank"
            style={{ color: '#08205e', textDecoration: 'underline' }}
            rel="noopener noreferrer"
          >
            HERE
          </a>{' '}
          and enter the required information:
        </ResultsOrderNumber>
        <br />
        <br />
        <ResultsOrderNumber className="order-number">Order Id: </ResultsOrderNumber> {result['orderId']} <br />
        <ResultsOrderNumber className="order-number">Zip Code: </ResultsOrderNumber> {result['zipCode']} <br />
        <ResultsOrderNumber className="order-number">Item(s): </ResultsOrderNumber> {result['productTitles']} <br />
        <ResultsOrderNumber className="order-number" style={{ display: result['trackingNumber'] ? 'block' : 'none' }}>
          Tracking:{' '}
          <a
            href={'https://www.google.com/search?q=track+' + result['trackingNumber']}
            target="_blank"
            style={{ color: '#08205e', textDecoration: 'underline' }}
            rel="noopener noreferrer"
          >
            {result['trackingNumber']}
          </a>
        </ResultsOrderNumber>{' '}
        <br />
      </ResultsNameColumn>
    </ResultRow>
  );
};

export default ZendeskOrderSearchResult;
